import { useCurrentStateAndParams } from "@uirouter/react";

import { TopicItem } from "app/pages/activation/components/Topics/Item/TopicItem";
import type { TopicItemSchema } from "app/pages/activation/components/Topics/Modal/types";

type SuggestedListSchema = {
    items: Partial<TopicItemSchema>[];
    selectedTopics: string[];
    selectTopic: (keyword: string, isSuggestion: boolean) => () => void;
    isMaxSelected: boolean;
    isMaxForOneAddSelected: boolean;
};

export const SuggestedList = ({
    items,
    selectedTopics,
    isMaxSelected,
    isMaxForOneAddSelected,
    selectTopic,
}: SuggestedListSchema) => {
    const {
        params: { timeGranularity: granularity },
    } = useCurrentStateAndParams();

    return items.map(({ volume, topicName, isSuggestion }) => {
        const isSelected = selectedTopics.includes(topicName);

        return (
            <TopicItem
                granularity={granularity}
                key={topicName}
                topicName={topicName}
                selectTopic={selectTopic}
                isSelected={isSelected}
                isSuggestion={isSuggestion}
                volume={volume}
                isMaxSelected={isMaxSelected || isMaxForOneAddSelected}
            />
        );
    });
};

SuggestedList.displayName = "SuggestedList";
